import { useState, useEffect } from 'react';

const Toggle = ({ toggle, onChange }) => {

    const [isChecked, setIsChecked] = useState(toggle.active)

    const checkHandler = () => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
        if (onChange) {
            onChange(toggle.value, newCheckedState);
        }
    };

    useEffect(() => {
        setIsChecked(toggle.active);
    }, [toggle.active]);

    return (
        <div className="d-flex flex-row align-items-center">
            <span className="switch-label">{toggle.label}</span>
            <label className="switch">
                <input
                    type="checkbox"
                    value={toggle.active}
                    checked={isChecked}
                    onChange={checkHandler}
                />
                <span className="slider"></span>
            </label>
        </div>
    );
};

export default Toggle;
